export const exampleTypes = {
    loadOne: "[example] loadOne",
    removeOne: "[example] removeOne",
    clean: "[example] clean",
};
